// extracted by mini-css-extract-plugin
export default {"starterScreen":"tp","starterImage":"up","already":"vp","starterImageMobile":"wp","controlX":"xp","starterTextContain":"yp","starterHeader":"zp","starterBtn":"Ap","starterSecondaryBtn":"Bp","starterBanner":"Cp","mobileBtnContainer":"Ep"};
    if(module.hot) {
      // 1730991501907
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  